import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  matchId: '',
  selectedMarkets: [],
  oddsDetails: [],
  tennisOddsDetails: [],
  marketsDisplayed: {},
  tennisMarketsDisplayed: {},
  downloadedExcelFile: null,
  downloadedTennisExcelFile: null,
};

export const oddsHistorySlice = createSlice({
  name: 'oddsHistory',
  initialState,
  reducers: {
    aSetSelectedRowMatchId: (state, action) => {
      state.matchId = action.payload.selectedRowMatchId;
    },
    aSetSelectedMarkets: (state, action) => {
      state.selectedMarkets = action.payload.selectedMarkets;
    },
    aGetOddsDetailsSuccess: (state, action) => {
      state.oddsDetails = action.payload.oddsDetails;
      state.marketsDisplayed = action.payload.marketsDisplayed;
    },
    aGetTennisOddsDetailsSuccess: (state, action) => {
      state.tennisOddsDetails = action.payload.oddsDetails;
      state.tennisMarketsDisplayed = action.payload.marketsDisplayed;
    },
    aExportToExcellSuccess: (state, action) => {
      state.downloadedExcelFile = action.payload.downloadedExcelFile;
    },
    aExportTennisToExcellSuccess: (state, action) => {
      state.downloadedTennisExcelFile = action.payload.downloadedExcelFile;
    },
    aClearOddsDetails: (state) => {
      state.oddsDetails = [];
      state.marketsDisplayed = {};
    },
    aClearTennisOddsDetails: (state) => {
      state.tennisOddsDetails = [];
      state.tennisMarketsDisplayed = {};
    },
  },
});

export const {
  aSetSelectedRowMatchId,
  aSetSelectedMarkets,
  aGetOddsDetailsSuccess,
  aGetTennisOddsDetailsSuccess,
  aExportToExcellSuccess,
  aExportTennisToExcellSuccess,
  aClearOddsDetails,
  aClearTennisOddsDetails,
} = oddsHistorySlice.actions;

export default oddsHistorySlice.reducer;

